exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comSelect-container .el-select{width:100%}", ""]);

// exports
